import React from "react";
import { Link } from "react-router";

export const LinkCell = ({ dataItem, field, tdProps, href, target = "_blank", external = false }) => {
    const value = dataItem?.[field];

    // If your link is to an external site, pass the prop external={true}
    if (external) {
        return (
            <td {...tdProps}>
                <a href={href} target={target} rel="noopener noreferrer">
                    {value}
                </a>
            </td>
        );
    }

    return (
        <td {...tdProps}>
            <Link to={href}>{value}</Link>
        </td>
    );
};